"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CompareStore {
  listingIds: string[];
  setAllListings: (listingIds: string[]) => void;
  addNewListing: (listingId: string) => void;
  removeListing: (listingId: string) => void;
  removeAll: () => void;
  toggleListing: (listingId: string) => boolean;
  isIncluded: (listingId: string) => boolean;
}

export const useCompareStore = create(
  persist<CompareStore>(
    (set, get) => ({
      listingIds: [],
      setAllListings: (listingIds: string[]) =>
        set(() => ({
          listingIds,
        })),
      addNewListing: (listingId: string) =>
        set((state) => ({
          listingIds: [...state.listingIds, listingId],
        })),
      removeListing: (listingId: string) =>
        set((state) => ({
          listingIds: state.listingIds.filter((id) => id !== listingId),
        })),
      // toggleListing: (listingId: string) =>
      //   get().isIncluded(listingId)
      //     ? get().removeListing(listingId)
      //     : get().addNewListing(listingId),
      toggleListing: (listingId: string) => {
        if (get().isIncluded(listingId)) {
          get().removeListing(listingId);
          return false;
        } else {
          get().addNewListing(listingId);
          return true;
        }
      },
      isIncluded: (listingId: string) => get().listingIds.includes(listingId),
      removeAll: () => set(() => ({ listingIds: [] })),
    }),
    {
      name: "compare-storage",
    }
  )
);
